
import { includesValidator } from '../../common/utils/validator';

const MenuGroupSize = {
  Medium: 'medium',
  Small: 'small',
};
export default {
  name: 'BbMenuGroup',
  props: {
    title: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: MenuGroupSize.Medium,
      validator: includesValidator(MenuGroupSize),
    },
  },
};
